export default __webpack_public_path__ + "static/media/Animated-Gift-Box.ae576168.gif";